import {
  PARSE_HARMONY_TITLE,
  PARSE_HARMONY_GALLERY,
  PARSE_HARMONY_PRICING,
  GET_HARMONY_FULFILLMENT,
  APP_MOUNT,
  PARSE_DYNAMIC_TAB_TITLE,
  PARSE_HARMONY_ID,
} from '../actions/actionTypes';

const initialState = {
  harmonyPricing: {},
  harmonyGallery: {},
  harmonyTitle: {},
  harmonyId: {},
  dynamicTabTitle :null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PARSE_HARMONY_ID:
      return {
        ...state,
        harmonyId: action.itemId,
      };
    case PARSE_DYNAMIC_TAB_TITLE:
      return {
        ...state,
        dynamicTabTitle: action.dynamicTabTitle,
      };
    case PARSE_HARMONY_TITLE:
      return {
        ...state,
        harmonyTitle: action.harmonyTitle,
      };
    case PARSE_HARMONY_GALLERY:
      return {
        ...state,
        harmonyGallery: action.harmonyGallery,
      };
    case PARSE_HARMONY_PRICING:
      return {
        ...state,
        harmonyPricing: action.harmonyPricing,
      };
    case GET_HARMONY_FULFILLMENT:
      return {
        ...state,
        harmonyFulfillment: action.harmonyFulfillment.items[0],
      };
    case APP_MOUNT: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};
